import './app/app.ts';
import './app/bible.ts'
import './app/bible-header.ts'
import './app/bible-verse.ts'
import './app/verse-panel.ts'
import './app/book-navigator.ts'

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('sw.js');
}
